import { render, staticRenderFns } from "./AccountCoin.vue?vue&type=template&id=5f343504&"
import script from "./AccountCoin.vue?vue&type=script&lang=ts&"
export * from "./AccountCoin.vue?vue&type=script&lang=ts&"
import style0 from "./AccountCoin.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports